var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.981c.01 5.51-4.483 10.015-9.993 10.019a9.958 9.958 0 0 1-6.283-2.214.967.967 0 0 1-.074-1.436l.454-.454a.97.97 0 0 1 1.286-.08A7.39 7.39 0 0 0 10 17.419 7.415 7.415 0 0 0 17.42 10 7.415 7.415 0 0 0 10 2.58a7.394 7.394 0 0 0-5.083 2.014l2.046 2.047a.645.645 0 0 1-.456 1.101H.645A.645.645 0 0 1 0 7.097V1.235A.645.645 0 0 1 1.101.779l1.991 1.99A9.966 9.966 0 0 1 10 0c5.517 0 9.99 4.467 10 9.981Zm-7.295 3.177.396-.51a.968.968 0 0 0-.17-1.357l-1.64-1.277V5.806a.968.968 0 0 0-.968-.967h-.646a.968.968 0 0 0-.967.967v5.47l2.637 2.052a.968.968 0 0 0 1.358-.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default ForwardRef;